export const getTahunOptions = () => {
  const tahunAktif = new Date().getFullYear();
  const tahunMulai = 2021;
  const tahunList: number[] = [];
  
  for (let i = tahunMulai; i <= tahunAktif; i++) {
    tahunList.push(i);
  }
  
  return tahunList.map(t => ({ value: t, label: t }));
};
